import type { ReactNode } from 'react'

interface PageTitleProps {
  icon: ReactNode
  title: string
  description: string
  action?: ReactNode
}

export function PageTitle({ icon, title, description, action }: PageTitleProps) {
  return <header className="page-title"><div className="page-title-icon">{icon}</div><div><h1>{title}</h1><p>{description}</p></div>{action && <div className="page-title-action">{action}</div>}</header>
}
